import { toJS } from 'mobx';
import isEqual from 'lodash/isEqual';

import Product from '../entity/Product';

export function formDiff(product: Product, form: Product) {
  const formJSON = toJS(form);
  const productJSON = toJS(product);

  const formObjectKeys = Object.keys(formJSON);

  return formObjectKeys.reduce<Nullable<Record<string, unknown>>>((result, formKey) => {
    // todo should use toQueryString and deserialize methods in entities
    if (
      formKey === 'mediaCollection' ||
      formKey === 'certifications' ||
      formKey === 'visibility' ||
      formKey === 'fancyColorGrade'
    ) {
      return result;
    }

    let formValue: unknown = formJSON[formKey as keyof Product];
    let productValue: unknown = productJSON[formKey as keyof Product];

    if (formValue instanceof Object && 'id' in formValue && formValue.id) {
      formValue = formValue.id;
    }

    if (productValue instanceof Object && 'id' in productValue && productValue.id) {
      productValue = productValue.id;
    }

    if (productValue === '') {
      productValue = null;
    }

    if (formValue === '') {
      formValue = null;
    }

    const isEqualObjects =
      productValue instanceof Object && formValue instanceof Object && isEqual(productValue, formValue);

    if (isEqualObjects) {
      return result;
    }

    if (formValue !== productValue || (formValue === null && productValue === undefined)) {
      if (!result) {
        result = {};
      }

      result[formKey] = formValue;
    }

    return result;
  }, null);
}
